import React from 'react';
import Box from '@material-ui/core/Box';

import HorizontalImageSwiper from 'on_web/components/shared/Swiper/HorizontalImageSwiper';

import { SKINCARE_COLOR } from 'colours';

import {
  qNav1Selected,
  qNav2Selected,
  qNav2NotSelected,
  qNavScSelected,
  qNavScNotSelected,
} from 'on_web/assets/imageList';

import {
  ROUTE_PCE_ONBOARDING_DNA,
  ROUTE_PCE_ONBOARDING_GENERAL,
  ROUTE_PCE_ONBOARDING_SKINCARE,
} from 'routes';

export default function PceStepProgressIndicator(props) {
  return (
    <Box justifyContent="center" display="flex">
      <HorizontalImageSwiper
        uid={'navigation-swiper'}
        selectedSlideIx={props.selectedSlideIx}
        slideClassName={'q-nav-swiper-slide'}
        items={[
          {
            selectedImg: qNav1Selected,
            unselectedImg: qNav1Selected,
            text: 'DNA',
            link: props.selectedSlideIx > 0 ? ROUTE_PCE_ONBOARDING_DNA : '#',
          },
          {
            selectedImg: qNav2Selected,
            unselectedImg: qNav2NotSelected,
            text: 'GENERAL',
            link:
              props.selectedSlideIx > 1 ? ROUTE_PCE_ONBOARDING_GENERAL : '#',
          },
          {
            selectedImg: qNavScSelected,
            unselectedImg: qNavScNotSelected,
            text: 'SKINCARE',
            textColor: SKINCARE_COLOR,
            link:
              props.selectedSlideIx > 2 ? ROUTE_PCE_ONBOARDING_SKINCARE : '#',
          },
        ]}
      />
    </Box>
  );
}
